import keyMirror from "keymirror";

const toolbarActions = keyMirror({
  CLEAR: true,
  LINK: true,
  IMPORT: true,
  EXPORT: true
});

export default toolbarActions;



// WEBPACK FOOTER //
// ./src/demo/components/toolbar/toolbarActions.js